<template>
  <div>
    <Modal v-model="modalShow" @on-cancel="onCancel">
      <Form style="margin-top:30px" :model="formData" :label-width="80">
        <FormItem label="上传附件">
          <plt-upload ref="excelRef" @success="uploadSuccess" :multiple="false" :height="70" :width="300" title="上传附件" @delete="onDelete"></plt-upload>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" @click="submit">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import pltUpload from "@/components/upload/upload.vue";
export default {
  components: { pltUpload },
  data() {
    return {
      modalShow: false,
      formData: {
        logiSubTaskId: "",
        receiveNoteIdList: [],
      },
    };
  },
  methods: {
    openModal(id) {
      this.formData.logiSubTaskId = id;
      this.modalShow = true;
    },
    uploadSuccess({ body }) {
      this.formData.receiveNoteIdList.push(body);
    },
    onDelete() {
      this.formData.receiveNoteIdList = [];
    },
    onCancel() {
      this.modalShow = false;
      this.onDelete();
      this.$refs["excelRef"].$refs["uploadFile"].clearFiles();
    },
    submit() {
      if (!this.formData.receiveNoteIdList.length)
        return this.$Message.warning("请上传附件");
      let data = {
        url: "http://MID-OPERATE-LOGISTICS/messageService/logisticSubTaskService/appendReceiveNodeIdList",
        body: { ...this.formData },
      };
      this.invoke(data, true).then((res) => {
        this.$Message.success("操作成功");
        this.onCancel();
      });
    },
  },
};
</script>

<style lang="sass" scoped>
</style>